import React, { useState } from 'react'
import { useRestaurant } from 'shared/components/common/restaurant_context/RestaurantContext'
import { ChevronRightIcon } from '@toasttab/buffet-pui-icons'
import { useOOLocations } from 'public/components/online_ordering/FulfillmentContext'
import ChangeLocationModal from './ChangeLocationModal'

export const LocationSelector = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { selectedLocation } = useRestaurant()
  const ooLocations = useOOLocations()

  if (!ooLocations?.length || ooLocations.length === 1) {
    return null
  }

  if (!selectedLocation) {
    return null
  }

  return (
    <div className='locationSelector'>
      <button
        className='locationSelectorButton'
        onClick={() => setIsModalOpen(true)}
        data-testid='location-selector-button'
        aria-label={`Change location from ${selectedLocation.name}`}
      >
        <div className='location-info'>
          <span className='location-name'>{selectedLocation.name}</span>
        </div>
        <div className='rightChevron' data-testid='location-selector-chevron'>
          <ChevronRightIcon
            testId='location-selector-chevron-icon'
            accessibility='decorative'
            className='chevron'
          />
        </div>
      </button>
      <ChangeLocationModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </div>
  )
}
